<mat-toolbar 
  setColor
  [setColorRules]="[
    {
      color: 'primaryColour',
      style: 'background'
    }
  ]" 
  color="primary" 
  class="header selected"
  data-cy="header-toolbar"
  role="banner"
  aria-label="Application header">

  <div class="header__title" role="group" aria-label="Primary navigation and branding" data-cy="header-branding">
    <app-navigation-menu></app-navigation-menu>

    <ng-container *ngIf="this.companyLogosService.activeCompanyLogo !== undefined; else noLogo">
      <img class="company-logo" [src]="this.companyLogosService.activeCompanyLogo" alt="Company logo" data-cy="header-company-logo"/>
    </ng-container>
    <ng-template #noLogo>
      <img class="hubbub-logo" [src]="this.environmentService.env.customLogoPath ? this.environmentService.env.customLogoPath : 'assets/HubbubHrLogo.svg'" alt="Hubbub HR logo" data-cy="header-default-logo"/>
    </ng-template>

  </div>

  <app-site-search-bar></app-site-search-bar>

  <div class="header-toolbar" role="group" aria-label="Header actions" data-cy="header-actions">
    <!-- <app-email></app-email> -->
    <app-notifications></app-notifications>
    <app-chat-launcher></app-chat-launcher>
    <button
      mat-icon-button
      class="accessibility-toggle"
      (click)="accessibilityService.toggle()"
      [attr.aria-pressed]="accessibilityService.isEnabled"
      [attr.aria-label]="(accessibilityService.isEnabled ? 'Disable' : 'Enable') + ' accessibility mode'"
      [matTooltip]="(accessibilityService.isEnabled ? 'Disable' : 'Enable') + ' accessibility mode'"
      data-cy="header-accessibility-toggle"
    >
      <mat-icon class="material-icons-outlined" aria-hidden="true">accessibility_new</mat-icon>
    </button>
    <app-translate></app-translate>
    <app-user [user]="user$" (signOut)="signOut()"></app-user>
  </div>

</mat-toolbar>
